import React from 'react';
import { Button, ButtonGroup } from '../../ui-kit';
import styled from 'styled-components';
import { IconThumbsDown, IconThumbsUp } from '../../ui-kit/icons';

import ContractStatisticsProgress from '../../contracts/ContractStatisticsProgress';
import ContractConstraintIndicator from '../../contracts/ContractConstraintIndicator';
import GroupScheduleButton from '../../general/GroupScheduleButton';
import { FormattedDates, formatTimeHuman } from '../../../utils/time';
import round from '../../../utils/round';
import { styleClasses as dutyExchangeIntervalStatus } from './TransactionUserStateLabel';

const TdWrapperSmall = styled.div`
  max-width: 150px;
  min-width: 150px;
`;

const TdWrapperBalance = styled.div`
  max-width: 70px;
  min-width: 70px;
`;

const balance = value => {
  const roundedValue = round(value, 2);

  if (value > 0) {
    return `+${roundedValue}`;
  }

  return roundedValue;
};

const constraintValue = (interval, constraintName) => {
  if (!interval.contractStatistics) return 0;
  if (!interval.contractStatistics.constraint_evaluation) return 0;
  const constraint = interval.contractStatistics.constraint_evaluation.find(
    evaluation => evaluation.name === constraintName
  );
  return round(constraint.value, 2);
};

const TableRequestedRow = props => {
  const acceptURL = `/groups/${
    props.dutyRequest.group.id
  }/schedule/exchanges/duty_exchange_intervals/${props.interval.id}/accept`;
  const rejectURL = acceptURL.replace('accept', 'reject');

  const canRespond = props.can_respond_on_behalf || props.interval.user_id === props.current_user_id;

  return (
    <tr>
      <td>
        <FormattedDates start={props.interval.start_time} end={props.interval.end_time} />
      </td>
      <td>
        <span className="user user-popup" data-user-id={props.interval.user.id}>
          <span className="user user-popup">{props.interval.user.nickname}</span>
        </span>
      </td>
      <td>
        {props.interval.user_stations.map(station => (
          <GroupScheduleButton
            startTime={props.interval.start_time}
            endTime={props.interval.end_time}
            station={station}
            key={station.id}
          />
        ))}
      </td>
      <td>
        <TdWrapperSmall>
          <ContractStatisticsProgress contractStatistics={props.interval.contractStatistics} />
        </TdWrapperSmall>
      </td>
      <td className="number-column">
        <TdWrapperBalance>
          {props.interval.contractStatistics &&
            props.interval.contractStatistics.balance &&
            balance(props.interval.contractStatistics.balance)}
        </TdWrapperBalance>
      </td>
      <td className="contract-constraints">
        <ContractConstraintIndicator contractStatistics={props.interval.contractStatistics} />
        {'  '}
        {props.selectedConstraint && constraintValue(props.interval, props.selectedConstraint)}
      </td>
      <td>
        <span className={dutyExchangeIntervalStatus[props.interval.state]}>
          {I18n.t(`classy_enum.schedule/exchanges/duty_exchange_interval_status.${props.interval.state}`)}
        </span>
      </td>
      <td>{props.interval.responded_at && formatTimeHuman(props.interval.responded_at)}</td>
      {props.canRespondAny && (
        <td>
          {/* current user can respond to own intervals, or any if has the rights to resolve */}
          {canRespond && props.interval.state === 'pending' && (
            <ButtonGroup>
              <Button href={acceptURL} variant="success">
                <IconThumbsUp />
              </Button>
              <Button href={rejectURL} variant="danger">
                <IconThumbsDown />
              </Button>
            </ButtonGroup>
          )}
        </td>
      )}
      {props.can_resolve && (
        <td>
          {props.interval.may_resolve && props.interval.may_select && (
            <input
              className="selected_duty_transaction_intervals"
              name="selected_duty_transaction_intervals[]"
              value={props.interval.id}
              type="checkbox"
            />
          )}
        </td>
      )}
    </tr>
  );
};

export default TableRequestedRow;
